<template><section><h2>text</h2>
<demo-block>
                  <div slot="source"><weui-footer>
  <weui-footer-text>Copyright © 2008-2016 weui.io</weui-footer-text>
</weui-footer>
</div>
                  
                  <template slot="highlight"><pre v-pre><code class="html">&lt;weui-footer&gt;
  &lt;weui-footer-text&gt;Copyright © 2008-2016 weui.io&lt;/weui-footer-text&gt;
&lt;/weui-footer&gt;
</code></pre></template></demo-block><h2>link</h2>
<demo-block>
                  <div slot="source"><template>
  <weui-footer>
    <weui-footer-links>
      <weui-footer-link @onClick="show()">底部链接</weui-footer-link>
    </weui-footer-links>
    <weui-footer-text>Copyright © 2008-2016 weui.io</weui-footer-text>
  </weui-footer>

  <weui-footer>
    <weui-footer-links>
      <weui-footer-link>底部链接</weui-footer-link>
      <weui-footer-link>底部链接</weui-footer-link>
    </weui-footer-links>
    <weui-footer-text>Copyright © 2008-2016 weui.io</weui-footer-text>
  </weui-footer>
</template>

</div>
                  
                  <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;weui-footer&gt;
    &lt;weui-footer-links&gt;
      &lt;weui-footer-link @onClick=&quot;show()&quot;&gt;底部链接&lt;/weui-footer-link&gt;
    &lt;/weui-footer-links&gt;
    &lt;weui-footer-text&gt;Copyright © 2008-2016 weui.io&lt;/weui-footer-text&gt;
  &lt;/weui-footer&gt;

  &lt;weui-footer&gt;
    &lt;weui-footer-links&gt;
      &lt;weui-footer-link&gt;底部链接&lt;/weui-footer-link&gt;
      &lt;weui-footer-link&gt;底部链接&lt;/weui-footer-link&gt;
    &lt;/weui-footer-links&gt;
    &lt;weui-footer-text&gt;Copyright © 2008-2016 weui.io&lt;/weui-footer-text&gt;
  &lt;/weui-footer&gt;
&lt;/template&gt;
&lt;script&gt;
  export default {
    methods: {
      show: function() {
        console.log('click')
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2>fixed</h2>
<demo-block>
                  <div slot="source"><weui-footer :fixed="true">
  <weui-footer-links>
    <weui-footer-link>WeUI首页</weui-footer-link>
  </weui-footer-links>
  <weui-footer-text>Copyright © 2008-2016 weui.io</weui-footer-text>
</weui-footer>
</div>
                  
                  <template slot="highlight"><pre v-pre><code class="html">&lt;weui-footer :fixed=&quot;true&quot;&gt;
  &lt;weui-footer-links&gt;
    &lt;weui-footer-link&gt;WeUI首页&lt;/weui-footer-link&gt;
  &lt;/weui-footer-links&gt;
  &lt;weui-footer-text&gt;Copyright © 2008-2016 weui.io&lt;/weui-footer-text&gt;
&lt;/weui-footer&gt;
</code></pre></template></demo-block><h2>Attributes</h2>
<h3>weui-footer</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>fixed</td>
<td>是否固定在底部</td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
</tbody>
</table>
<h2>Event</h2>
<h3>weui-footer-link</h3>
<table>
<thead>
<tr>
<th>事件名称</th>
<th>说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>onClick</td>
<td>点击事件回调</td>
<td>function()</td>
</tr>
</tbody>
</table>
</section></template>

<script>
  export default {
    methods: {
      show: function() {
        console.log('click')
      }
    }
  }
</script>